import {useEffect, useState} from "react";
export const QuestionManageComponent = ({original,translate}) => {
    const [processedData, setProcessedData] = useState([]);

    const mappingData = (original, translate) => {
        const originalArray = original.split(/[.\n]/).map(it => it.trim()).filter(it => it !== '');
        const translateArray = translate.split(/[.\n]/).map(it => it.trim()).filter(it => it !== '');
        const data = originalArray.map((item, index) => ({
            original: item,
            translate: translateArray[index],
        }))
        return data.map(item => ({
            originalText: item.original,
            translateText: item.translate,
            exampleText: item.translate,
        }));
    };

    useEffect(() => {
        if (translate === '') return;
        const newData = mappingData(original, translate);
        setProcessedData(newData);
    }, [original, translate]);

    const onChange = (index, type, event) => {
        const {value} = event.target;
        setProcessedData(prevData => {
            const newData = [...prevData];
            newData[index] = {
                ...newData[index],
                [type]: value,
            };
            return newData;
        });
    };

    if (processedData.length === 0) {
        return null;
    }

    return (<>
        <h1>original : {original}</h1>
        <ul className={`flex gap-3`}>
            <li className={`w-full px-2 py-3 bg-slate-800 text-white `}>원문:</li>
            <li className={`w-full px-2 py-3 bg-slate-800 text-white `}>번역본:</li>
            <li className={`w-full px-2 py-3 bg-slate-800 text-white `}>비교화면:</li>
            <li className={`w-full px-2 py-3 bg-slate-800 text-white `}>에디터:</li>
        </ul>
        <div className={`w-full flex gap-3 `} style={{maxWidth: '1200px'}}>
            <textarea disabled={true} className={'w-full h-full  border p-1'}
                defaultValue={processedData.map(it => it.originalText).join('. ')}
            >
                {/*원문*/}
            </textarea>
            <textarea disabled={true} className={'w-full h-full  border p-1'}
                defaultValue={processedData.map(it => it.translateText).join('. ')}>
            </textarea>
            <textarea disabled={true} className={'w-full h-full  border p-1'}>
                {processedData.map(it => it.exampleText).join('. ')}
            </textarea>
            <ul className={`w-full gap-3 `}>

            {processedData.map((item, index) =>
            <li className={'w-full'}><textarea className={'w-full  border p-1'}
                defaultValue={item.exampleText}
                onChange={(e) =>
                    onChange(index, 'exampleText', e)}
            >
                {/*에디터*/}
            </textarea></li>
            )}
            </ul>
        </div>
    </>);
}